import React, { useEffect } from 'react';
import DashboardView from './DashboardView';
import {
  IDataProviderService,
} from 'types/types';
import DataProviderService from 'services/DataProviderService';
import { useParams } from 'react-router-dom';
import {
  setDashboardDescriptor,
  dashboards,
  visibleDashboardId,
} from 'features/dashboardsState';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'types/types';
const MemoizedDashboardView = React.memo(DashboardView);
import LocalForageService from 'services/LocalForageService';

const DashboardCreator: React.FC = () => {
  const dispatch = useDispatch();
  const { dashboardId } = useParams();
  const dashboardsState =
    useSelector((state: RootState) => dashboards(state)) || [];
  const visibleDashboard = useSelector(visibleDashboardId);
  useEffect(() => {
    const lsService = new LocalForageService();
    if (!dashboardId) return;
    const loadDashboardDescriptor = async (dashboardId: any) => {
      try {
        const dpService: IDataProviderService = new DataProviderService();
        const descriptor = await dpService.getDashboardDescriptor(dashboardId);
        dispatch(setDashboardDescriptor({ dashboardId, descriptor }));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    // if();
    lsService.getItem('dashboards').then((dashboardsData) => {
      if (!dashboardsData) {
        loadDashboardDescriptor(dashboardId);
      } else {
        const dashboard = dashboardsData.find(
          (_) => _.dashboardId === dashboardId
        );
        if (!dashboard) {
          loadDashboardDescriptor(dashboardId);
        } else {
          const descriptor = dashboard.descriptor;
          dispatch(setDashboardDescriptor({ dashboardId, descriptor }));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardId]);

  return (
    <>
      {dashboardsState.map((dashboard) => (
        <div
          key={'dc-' + dashboard.dashboardId}
          style={{
            height: '100%',
            display:
              visibleDashboard === dashboard.dashboardId ? 'block' : 'none',
          }}
        >
          {visibleDashboard === dashboard.dashboardId && (
            <MemoizedDashboardView {...dashboard.descriptor} />
          )}
        </div>
      ))}
    </>
  );
};

export default DashboardCreator;
